define(['bing'], function (BingMaps) {
   "use strict";

   return {
      // (MS Bing Map Key 11/29/2011, RFG BTT.)
      bingmapCredentials: "AqK6Xm4vKQ14R0qING7QBL3FFqQDNoHrM0xVWiVT9yyukhvj7q6TBcylAn6DbA0o",

      handleHash: function (oHash) {
         // TODO: c21.maps handleHash
         //var strPdp = oHash.pdp;
         //if (strPdp) {
         //   c21.propertydetails.openModalHashAction(strPdp);
         //} else {
         //   c21.propertydetails.closeModalHashAction();
         //}
      },

      /**
       * Convert a location to a z-index attribute
       * @param {number} latitude
       * @param {number} longitude
       * @return {number}
       */
      getZindexFromLoc: function (latitude, longitude) {
         var strLat = latitude,
            fLat = parseFloat(strLat);

         // We want pushpins in the bottom-right to show up on top
         // For latitude: North is higher, South is lower
         // For longitude: East is higher, West is lower

         // Important!: Bing will IGNORE any zIndex with decimals
         return Math.floor(100000 - (fLat * 1000));
      },

      /**
       * Adds hoverIntent to pins, in a snazzy function
       * @param {Microsoft.Maps.Map} map
       * @param {Microsoft.Maps.Pin} pin
       * @param {function} fnMouseOver
       * @param {function} fnMouseOut
       */
      onPinHoverIntent: function (map, pin, fnMouseOver, fnMouseOut) {
         var iWaitTime = 500,
            iMouseOut = 0;

         // This method adds a custom property to the map
         map.iTimeoutMouseOver = 0;

         // When mouseover on this pin
         BingMaps.Events.addHandler(pin, 'mouseover', function (e) {
            // Cancel mouseover events for other pins
            clearTimeout(map.iTimeoutMouseOver);

            // Cancel the mouseout event for this pin
            clearTimeout(iMouseOut);

            map.iTimeoutMouseOver = setTimeout(fnMouseOver, iWaitTime);
         });

         // When mouseout on this pin
         BingMaps.Events.addHandler(pin, 'mouseout', function (e) {
            // Cancel mouseover events for other pins
            clearTimeout(map.iTimeoutMouseOver);

            // Cancel any previous mouseout for this pin
            clearTimeout(iMouseOut);

            iMouseOut = setTimeout(fnMouseOut, iWaitTime);
         });
      },

      /**
       * Attaches a click event to the map.
       * This is different from the BingMaps 'click' event in that
       * when the user drags the map, the event does not trigger
       * @param {Microsoft.Maps.Map} map
       * @param {Function} fn  the callback function when the event is triggered
       */
      onMapClick: function (map, fn) {
         var bMouseDragged = false;

         BingMaps.Events.addHandler(map, 'mousedown', function (e) {
            bMouseDragged = false;
         });

         BingMaps.Events.addHandler(map, 'viewchangestart', function (e) {
            bMouseDragged = true;
         });

         BingMaps.Events.addHandler(map, 'mouseup', function (e) {
            if (bMouseDragged) {
               return;
            }
            fn(e);
         });
      }
   };
});
